export default "__VITE_ASSET__abf672a6__"